import React from 'react';
import PropTypes from 'prop-types';
import PortfolioItem from '@components/PortfolioItem';
import ScrollToPrevious from '@components/ScrollToPrevious';
import PortfolioItems from './portfolio-items';

import './style.scss';

const PortfolioPage = (props, context) => {
  const {
    theme: { colorPrimary, colorAlternate, textAlternate, bgPrimary }
  } = context;

  return (
    <div className="portfolio" style={{ backgroundColor: bgPrimary }}>
        <h1 style={{ color: colorPrimary, textAlign: 'center' }}>Example Work / Projects</h1>
        <div className="portfolio-wrapper">          
            <PortfolioItems />
        </div>
      <ScrollToPrevious pageSelector=".about-page" />
    </div>
  );
};

PortfolioPage.contextTypes = {
  theme: PropTypes.any
};

export default PortfolioPage;



// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/PortfolioPage.js